import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UsersSelectComponent } from '../users-select.component';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { UsersService } from '../users.service';
import { BehaviorSubject } from 'rxjs';
import { MessageService } from '@klickdata/core/message';
import { MessageErrorComponent } from '@klickdata/core/message/src/message-error/message-error.component';

@Component({
    selector: 'app-users-select-add-enrollment',
    templateUrl: './users-select-add-enrollment.component.html',
    styleUrls: ['./users-select-add-enrollment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [UsersService],
})
export class UsersSelectAddEnrollmentComponent extends UsersSelectComponent {
    public onCloseSelection: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    constructor(
        protected datatableService: UsersService,
        protected mobileService: MobileService,
        protected auth: AuthService,
        protected messageService: MessageService
    ) {
        super(datatableService, mobileService, auth);
    }
    notifyOnCloseSelection() {
        this.messageService.openMessage(
            MessageErrorComponent,
            $localize`You have reached the maximum number of users for this occasion`
        );
    }
}
